import Box from '@mui/material/Box';
import AddressInput from './AddressInput';
import FormControl from '@mui/material/FormControl';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import InputAdornment from '@mui/material/InputAdornment';

function Where(props) {
    const { errors, seaPorts, unlocode, nogmaps, source, destination, setSource, setDestination, transportationMethod, organization, accesstoken, disabledSource, disabledDestination, enableDoorLocations } = props;
    return (
        <Box sx={{ display: 'flex', gap: '8px' }}>
            <Box sx={{ flex: 1 }}>
                <FormControl variant='outlined' fullWidth>
                    <AddressInput
                        transportationMethod={transportationMethod}
                        value={(source || {}).text || ''}
                        textFieldProps={{
                            autoFocus: !source,
                            style: { borderRadius: '0px' },
                            placeholder: 'Where from?',
                            id: 'where-from',
                            disabled: disabledSource,
                            startAdornment: (
                                <InputAdornment position='start'>
                                    <LocationOnIcon />
                                </InputAdornment>
                            )
                        }}
                        onChange={(v) => {
                            if (!disabledSource) {
                                setSource(v);
                            }
                        }}
                        error={errors.includes('address-source-required') ? 'Route as to have an origin' : errors.includes('address-source') ? 'Please enter source port' : null}
                        seaPorts={seaPorts}
                        unlocode={unlocode}
                        nogmaps={nogmaps}
                        organization={organization}
                        accesstoken={accesstoken}
                        enableDoorLocations={enableDoorLocations}
                    />
                </FormControl>
            </Box>
            <Box sx={{ flex: 1 }}>
                <FormControl variant='outlined' fullWidth>
                    <AddressInput
                        transportationMethod={transportationMethod}
                        value={(destination || {}).text || ''}
                        textFieldProps={{
                            autoFocus: false,
                            style: { borderRadius: '0px' },
                            placeholder: 'Where to?',
                            id: 'where-to',
                            disabled: disabledDestination,
                            startAdornment: (
                                <InputAdornment position='start'>
                                    <LocationOnIcon />
                                </InputAdornment>
                            )
                        }}
                        onChange={(v) => {
                            if (!disabledDestination) {
                                setDestination(v);
                            }
                        }}
                        error={errors.includes('address-destination-required') ? 'Route as to have a destination' : errors.includes('address-destination') ? 'Please enter destination port' : null}
                        seaPorts={seaPorts}
                        unlocode={unlocode}
                        nogmaps={nogmaps}
                        organization={organization}
                        accesstoken={accesstoken}
                        enableDoorLocations={enableDoorLocations}
                    />
                </FormControl>
            </Box>
        </Box>
    )
}

export default Where;
